import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { JSX } from 'react';
import { AnimatedListInner } from './AnimatedListInner/AnimatedListInner';
import { ProspectData } from '@/types/salesforce';

export type AnimatedListProps = SliceComponentProps<
  Content.AnimatedListSlice,
  ProspectData
>;

const AnimatedList = ({ slice, context }: AnimatedListProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
    >
      <AnimatedListInner slice={slice} prospect={context} />
    </section>
  );
};

export default AnimatedList;
